module.exports = __webpack_public_path__ + "static/media/icn_health_insurance_f.aadd6a37.svg";